import { DDDStringFilter } from "@app/core/ddd-layout/dto/ddd-entity-select.request.dto";
import { InsuranceType } from "./types";

/**
 * @example
 * {
 *   fieldName: 'contractNumber',
 *   fieldType: 'string',
 *   filterType: 'like',
 *   value: value || '', // input value here
 * }
 *
 */
export const insuranceContractNumberLike = (value: string): DDDStringFilter => ({
    value: value ?? '',
    fieldName: 'contractNumber',
    fieldType: 'string',
    filterType: 'like',
});

/**
 * @example
 * {
 *   fieldName: 'registrationNumber',
 *   fieldType: 'string',
 *   filterType: 'like',
 *   value: value || '', // input value here
 * }
 *
 */
export const insuranceRegistrationNumberLike = (value: string): DDDStringFilter => ({
    value: value ?? '',
    fieldName: 'registrationNumber',
    fieldType: 'string',
    filterType: 'like',
});

/**
 * @example
 * {
 *   fieldName: 'status',
 *   fieldType: 'string',
 *   filterType: 'in',
 *   value: value || '', // input value here
 * }
 *
 */
export const insuranceStatusIn = (value) => ({
    value,
    fieldName: 'status',
    fieldType: 'string',
    filterType: 'in',
});

/**
 * @example
 * {
 *   fieldName: 'type',
 *   fieldType: 'string',
 *   filterType: 'equals',
 *   value, // input value here
 * }
 *
 */
export const typeInsuranceEquals = (value: InsuranceType) => ({
    value,
    fieldName: 'type',
    fieldType: 'string',
    filterType: 'equals',
});

/**
 * @example
 * {
 *   fieldName: 'email',
 *   fieldType: 'string',
 *   filterType: 'equals',
 *   value, // input value here
 * }
 *
 */
export const emailEquals = (value) => ({
    value,
    fieldName: 'email',
    fieldType: 'string',
    filterType: 'equals',
});
